import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

const DropdownLoading = () => {
  return (
    <Stack spacing={1} p={2}>
      <Skeleton width="100%" />
      <Skeleton width="100%" />
      <Skeleton width="100%" />
    </Stack>
  )
}

export default DropdownLoading
